import Yup from 'utils/validation/yup-extensions';

export const REASSIGN_STEPS = {
	SELECT_USER: 'Select a User',
	SELECT_MANAGER: 'Select a New Manager',
	SELECT_SUBMIT: 'Submit',
};

/**
 * Keys to be used by Formik for Delegate form
 */
export const REASSIGN_FIELD_KEYS = {
	USERS_LIST: 'usersList',
	MANAGER: 'manager',
	SUBMIT: 'submit',
};

/**
 * mapping of the fields and which step index they belong to
 */
export const REASSIGN_FIELD_STEPS = {
	0: [REASSIGN_FIELD_KEYS.USERS_LIST],
	1: [REASSIGN_FIELD_KEYS.MANAGER],
	2: [REASSIGN_FIELD_KEYS.SUBMIT],
};

/**
 * Form field metadata (default values, validation schema)
 */
export const REASSIGN_FIELDS = {
	[REASSIGN_FIELD_KEYS.USERS_LIST]: {
		defaultValue: [],
		validationSchema: Yup.array()
			.min(1, 'Please select a non-employee.')
			.length(1, 'You must select one and only one user.')
			.test('Is User a Non-Employee', function (values) {
				if (values.length > 0) {
					if (values[0].accountCategoryName === 'EMPLOYEE') {
						return this.createError({
							message: 'The selected user is not a non-employee.',
						});
					}
					return true;
				}
			}),
		stepLocation: REASSIGN_STEPS.SELECT_USER,
		reviewLabel: 'Select User',
	},
};
